import { render } from "./statisticsDashboard.vue?vue&type=template&id=e341570c&scoped=true"
import script from "./statisticsDashboard.vue?vue&type=script&lang=js"
export * from "./statisticsDashboard.vue?vue&type=script&lang=js"

import "./statisticsDashboard.vue?vue&type=style&index=0&id=e341570c&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/tl-demo-web_v2.0.9.4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e341570c"]])

export default __exports__